import React, { useContext, useEffect, useState, useRef } from 'react'
import '../css/usersSettings.css'
import GlobalContext, { defaultValues } from '../GlobalContext'
import ServiceContext from '../ServiceContext'
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import TextContext from '../TextContext'
import { Form, FormControl, InputGroup, ModalFooter } from 'react-bootstrap'
import { useImmer } from 'use-immer';
import { RiCheckLine, RiCloseLine, RiEraserLine } from 'react-icons/ri';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import GoodNumber from '../components/GoodNumber';
import { passwordStrength } from 'check-password-strength';
import { useNavigate } from 'react-router-dom';


const defaultUserValues = {
    ID: undefined,
    use_username: '',
    use_language: { label: '', value: null },
    use_calendar_start: 9,
    use_calendar_end: 22,
    use_calendar_hour_format: '24',
    use_color: "#1000bf",
    Shop: { label: '', value: undefined },
    Group: { label: '', value: undefined },
}
const defaultUserChecks = {
    touched: {
        ID: false,
        use_username: false,
        use_language: false,
        use_calendar_start: false,
        use_calendar_end: false,
        use_calendar_hour_format: false,
        use_color: false,
        Shop: false,
        Group: false,
    },
    check: {
        ID: (v) => { return true },
        use_username: (v) => { return v && v.length > 0 && v.length < 50 },
        use_language: (v) => { return v },
        use_calendar_start: (v) => { return v && v > 1 },
        use_calendar_end: (v) => { return v && v < 23 },
        use_calendar_hour_format: (v) => { return true },
        use_color: (v) => { return true },
        Shop: (v) => { return true },
        Group: (v) => { return true },
    },
    good: {
        ID: false,
        use_username: false,
        use_language: false,
        use_calendar_start: false,
        use_calendar_end: false,
        use_calendar_hour_format: false,
        use_color: false,
        Shop: false,
        Group: false,
    },
    bad: {
        ID: false,
        use_username: false,
        use_language: false,
        use_calendar_start: false,
        use_calendar_end: false,
        use_calendar_hour_format: false,
        use_color: false,
        Shop: false,
        Group: false,
    },
}

const UsersSettings = ({ groupOptions = [], languageOptions = [], submitSignal, clearSignal }) => {

    const animatedComponents = makeAnimated();
    const globalContext = useContext(GlobalContext)
    const serviceContext = useContext(ServiceContext)
    const textContext = useContext(TextContext)
    const navigate=useNavigate()

    const [mode, setMode] = useState(true)
    const [selectedUser, setSelectedUser] = useState()
    const [userOptions, setUserOptions] = useState([])
    const [users, setUsers] = useState([])
    const [userNameMessage, setUserNameMessage]=useState("")    
    const [userValues, setUserValues] = useImmer(defaultUserValues)
    const [userCheks, setUserCheks] = useImmer(defaultUserChecks)
    const [shopOptions, setShopOptions] = useState(globalContext.get.shops.map(sho => ({ label: sho.sho_name, value: sho.ID })))
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [passwordMessage, setPasswordMessage] = useState('')
    const [resetColors, setResetColors] = useState(false)

    const colorRef = useRef("")

    const addUser=async()=>{

        if(!checkForm(userValues, userCheks, setUserCheks, true)){
            console.log('check non passato')
            return
        }
        if(!checkPassword(password)){
            console.log('check password non passato')
            return
        }

        const body = JSON.parse(JSON.stringify(userValues))  // create copy of user values to avoid unwanted changes in the original state
        body.Group_ID=body.Group.value
        delete body.Group
        body.Shop_ID=body.Shop.value
        delete body.Shop
        body.use_language=body.use_language.value
        body.use_password=password

        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        //console.log(body)
        // setUserNameMessage('')
        let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/users`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
        // const respValue = await resp.json()
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })

        if (resp.status == 200) {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['user_add'], textContext.value),
                    ttl: 2000
                })
            })
            setMode(true)
        } else if (resp.status === 201) {
            // setShowUsernameTakenMessage(true)
            // close = false
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['used_username'], textContext.value),
                    ttl: 2000
                })
            })
        } else {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_modify_utent'], textContext.value),
                    ttl: 2000
                })
            })
        }
    }
    const editUser=async()=>{

        if(!checkForm(userValues, userCheks, setUserCheks, true)){
            return
        }
        if(password.length>0&&!checkPassword(password)){
            return
        }

        const body = JSON.parse(JSON.stringify(userValues))  // create copy of user values to avoid unwanted changes in the original state
        body.Group_ID=body.Group.value
        delete body.Group
        body.Shop_ID=body.Shop.value
        delete body.Shop
        body.use_language=body.use_language.value
        if(password.length>0){
            body.use_password=password
        }

        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        //console.log(body)
        // setUserNameMessage('')
        let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/users`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
        // const respValue = await resp.json()
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })

        if (resp.status == 200) {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['modify_utent'], textContext.value),
                    ttl: 2000
                })
            })
        } else if (resp.status === 201) {
            // setShowUsernameTakenMessage(true)
            // close = false
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['used_username'], textContext.value),
                    ttl: 2000
                })
            })
        } else {
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_modify_utent'], textContext.value),
                    ttl: 2000
                })
            })
        }

        const respi = await fetch(`${globalContext.get.backendUrl}/login`, {
            method: 'GET',
            credentials: 'include',
        })

        if (respi.status != 200) {
            logout()
        } 
        

    }
    const clear=()=>{
        if(mode){
            changeUser(userOptions[0])
        } else {
            setUserValues(defaultUserValues)
            setUserCheks(defaultUserChecks)
            setUserNameMessage('')
            setPasswordMessage('')
            setShowPassword(false)
            setPassword('')
        }
    }
    const logout= async()=>{
        const resp = await fetch(`${globalContext.get.backendUrl}/login`, {
            method: 'DELETE',
            credentials: 'include',
        })
        const respValue = await resp.json()
        globalContext.set(defaultValues)
        navigate('/')
    }
    const changeUser = (option) => {
        setSelectedUser(option)

        let lang = languageOptions.filter(lang => lang.value == option.value.use_language)
        if (lang.length > 0) {
            lang = lang[0]
        } else {
            lang = { label: '', value: undefined }
        }

        let shop = shopOptions.filter(sho => sho.value == option.value.Shop_ID)
        // console.log(option.value)
        if (shop.length > 0) {
            shop = shop[0]
        } else {
            shop = { label: '', value: undefined }
        }

        let group
        if (option.value.UserGroups.length > 0) {
            const groupID = option.value.UserGroups[0].Group.ID
            group = groupOptions.filter(gro => gro.value == groupID)
            if (group.length > 0) {
                group = group[0]
            } else {
                group = { label: '', value: undefined }
            }
        } else {
            group = { label: '', value: undefined }
        }
        setUserValues({
            ID: option.value.ID,
            use_username: option.value.use_username,
            use_language: lang,
            use_calendar_start: option.value.use_calendar_start,
            use_calendar_end: option.value.use_calendar_end,
            use_calendar_hour_format: option.value.use_calendar_hour_format,
            use_color: option.value.use_color,
            Shop: shop,
            Group: group,
        })
        setUserCheks(defaultUserChecks)
        setUserNameMessage('')
        setPasswordMessage('')
        setShowPassword(false)
        setPassword('')
    }
    const changeColor = async (e) => {
        try {
            document.getElementById(e.target.id).value = e.target.value;
            colorRef.current = e.target.value
        }
        catch {
            return
        }
    }
    const checkForm = (values, check, setCheck, show = false) => {
        try {
            let pass = true
            Object.keys(values).forEach(k => {
                if (check.check[k](values[k])) {

                    if (show || check.touched[k]) {
                        setCheck(draft => { draft.good[k] = true })
                        setCheck(draft => { draft.bad[k] = false })
                    }
                } else {
                    pass = false
                    console.log(k,  values[k], 'fail')
                    if (show || check.touched[k]) {
                        setCheck(draft => { draft.bad[k] = true })
                        setCheck(draft => { draft.good[k] = false })
                    }
                }

            })
            return pass
        } catch {
            return false
        }
    }
    const checkUsername=async()=>{
        setUserNameMessage('')
        if(mode){
            if(userValues.use_username==selectedUser.value.use_username){
                return true
            }
        }
        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/users?username=${userValues.use_username}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        let respValue = await resp.json()
        if(resp.status==200){
            if(respValue.data){
                return true
            }
        }
        setUserCheks(draft=>{
            draft.bad.use_username=true
            draft.good.use_username=false
        })
        setUserNameMessage('Username già in uso')

    }
    const checkPassword=(e)=>{
        if(mode){
            if (e.length>0&&passwordStrength(e).id < 2) {
                setPasswordMessage('Password troppo debole')
                return false
            } else {
                setPasswordMessage('')
                return true
            }
        } else {
            if (passwordStrength(e).id < 2) {
                setPasswordMessage('Password troppo debole')
                return false
            } else {
                setPasswordMessage('')
                return true
            }
        }
    }
    const getPermission = (permission, pos = -1) => {
        if (globalContext.get) {
            if (globalContext.get.User) {
                if (globalContext.get.User.Groups) {
                    if (globalContext.get.User.Groups.length > 0) {
                        if (globalContext.get.User.Groups[0].gro_is_admin) {
                            return true
                        } else {
                            if (pos >= 0) {
                                return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos))
                            } else {
                                return globalContext.get.User.Groups[0][permission]
                            }
                        }
                    }
                }
            }
        }
        return false
    }
    const removeLang = () => {
        setUserValues(draft => {
            draft.use_language = { label: '', value: null }
        })
    }

    
    useEffect(() => {
        if (globalContext.get) {
            if (globalContext.get.User.ID && globalContext.get.Shop.ID && globalContext.get.Agency.ID) {
                let l_users = []
                let ids = []
                let l_groups = []
                //console.log('ESECUZIONE loop')
                globalContext.get.shops.forEach(sho => {
                    sho.Users.forEach(use => {
                        if (!ids.includes(use.ID)) {
                            ids.push(use.ID)
                            l_users.push(use)
                        }
                    })
                })
                const userGroup = globalContext.get.User.Groups[0]
                globalContext.get.Agency.Groups.forEach(gro => {
                    if (userGroup.gro_is_admin) {
                        if (!(gro.gro_is_admin && gro.gro_priority > userGroup.gro_priority)) {
                            l_groups.push({ label: gro.gro_name, value: gro.ID })
                        }
                    } else if (userGroup.gro_manage_groups) {
                        if (!(gro.gro_is_admin || gro.gro_priority > userGroup.gro_priority || gro.ID == userGroup.ID)) {
                            l_groups.push({ label: gro.gro_name, value: gro.ID })
                        }
                    }
                })
                setUserOptions(l_users.map(use => { return { label: use.use_username, value: use } }))
                changeUser({ label: l_users[0].use_username, value: l_users[0] })
                setUsers(l_users)
                if(!getPermission('gro_aer_user', 1)){
                    setMode(false)
                }
            }
        }
    }, [globalContext.get])
    useEffect(()=>{
        if(submitSignal.get){
            submitSignal.set(false)
            if(mode){
                editUser()
            } else {
                addUser()
            }
        }
    },[submitSignal.get])
    useEffect(()=>{
        if(clearSignal.get){
            clearSignal.set(false)
            clear()
        }
    },[clearSignal.get])
    useEffect(() => {
        checkForm(userValues, userCheks, setUserCheks)
        setResetColors(true)
    }, [userValues])
    useEffect(() => {
        if (resetColors) {
            setResetColors(false)
        }
    }, [resetColors])
    useEffect(() => {
        if (mode) {
            if (userOptions.length > 0) {
                changeUser(userOptions[0])
            }
        } else {
            clear()
        }
    }, [mode])


    return (
        <div className='uss-container'>
            <div className='uss-top-btn-row'>
                {mode ?
                    <button
                        type='button'
                        className='uss-top-btn'
                        onClick={() => { setMode(false) }}
                    >
                        Aggiungi nuovo
                    </button>
                    :
                    <button
                        type='button'
                        className='uss-top-btn'
                        onClick={() => { setMode(true) }}
                    >
                        Modifica esistente
                    </button>
                }
            </div>
            <hr className='hr-cool' style={{ width: '100%' }} />
            {getPermission('gro_aer_user', 0)&&getPermission('gro_aer_user', 1)?
            <>
            {mode ?
                <>
                    <div className='uss-top-btn-row'>
                        <p className='nac-title'>Modifica utente</p>
                    </div>
                    {/* //ANCHOR - EDIT - Selezione utente */}
                    <div className='uss-user-select-row mt-4'>
                        <Form.Label className='no-pm' ><p className='no-pm' >{textContext.get(['sidebar', 'settings', 'shop'], ['user_select'], textContext.value)}</p></Form.Label>
                        <Select
                            id='select-pttp'
                            className='uss-select'
                            components={animatedComponents}
                            options={userOptions}
                            isSearchable
                            value={selectedUser}
                            onChange={(e) => changeUser(e)}
                        />
                    </div>
                </>
                :
                <div className='uss-top-btn-row'>
                    <p className='nac-title'>Aggiungi utente</p>
                </div>
            }
            </>
            :<></>}
            {/* //ANCHOR - EDIT - Username */}
            <div className='uss-form-row mt-4'>
                <InputGroup>
                    <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'shop'], ['user_username'], textContext.value)}</InputGroup.Text>
                    <FormControl
                        type='text'
                        placeholder='giorgio67'
                        value={userValues.use_username}
                        onChange={(e) => setUserValues(draft => { draft.use_username = e.target.value })}
                        onFocus={(e) => setUserCheks(draft => { draft.touched.use_username = true })}
                        onBlur={checkUsername}
                        isValid={userCheks.good.use_username}
                        isInvalid={userCheks.bad.use_username}
                    />
                </InputGroup>
            </div>
                <p className='nac-text active' style={{ textAlign: 'end' }}>{userNameMessage}</p>
            {/* //ANCHOR - EDIT - Password */}
            {mode ?
                <div className='uss-form-row mt-4'>
                    <InputGroup>
                        <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'profile'], ['user_password'], textContext.value)}</InputGroup.Text>
                        <FormControl
                            type={showPassword ? 'text' : 'password'}
                            placeholder='password'
                            value={password}
                            onChange={(e) => {setPassword(e.target.value); checkPassword(e.target.value)}}
                            className='password-form'
                        />
                        <button type='button' className=' nac-button uss-password-btn'>
                            {showPassword ?
                                <AiFillEyeInvisible className='nac-text showPassword' size={'15pt'} onClick={() => { setShowPassword(!showPassword) }} />
                                :
                                <AiFillEye className='nac-text showPassword' size={'15pt'} onClick={() => { setShowPassword(!showPassword) }} />
                            }
                        </button>
                        {/* <button type='button' className='nac-button save-password-button' onClick={() => editPassword(userValues.ID)}>
                            <RiCheckLine size={'15pt'} />
                        </button> */}
                    </InputGroup>
                    
                </div>
                :
                <div className='uss-form-row mt-4'>
                    <InputGroup>
                        <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'profile'], ['user_password'], textContext.value)}</InputGroup.Text>
                        <FormControl
                            type={showPassword ? 'text' : 'password'}
                            placeholder='password'
                            value={password}
                            onChange={(e) => {setPassword(e.target.value); checkPassword(e.target.value)}}
                            className='password-form'
                        />
                        <button type='button' className='nac-button uss-password-btn'>
                            {showPassword ?
                                <AiFillEyeInvisible className='nac-text showPassword' size={'15pt'} onClick={() => { setShowPassword(!showPassword) }} />
                                :
                                <AiFillEye className='nac-text showPassword' size={'15pt'} onClick={() => { setShowPassword(!showPassword) }} />
                            }
                        </button>
                    </InputGroup>
                </div>
            }
            <p className='nac-text active' style={{ textAlign: 'end' }}>{passwordMessage}</p>
            {/* //ANCHOR - EDIT - Lingua */}
            <div className='uss-form-row mt-4'>
                <Form.Label className='no-pm' ><p className='no-pm' >Lingua</p></Form.Label>
                <Select
                    id='select-pttp'
                    className='uss-select'
                    components={animatedComponents}
                    options={languageOptions}
                    value={userValues.use_language}
                    onChange={(e) => setUserValues(draft => { draft.use_language = e })}
                />
                <button type='button' className='nac-button save-password-button' onClick={removeLang}>
                    <RiEraserLine size={'14pt'} />
                </button>
            </div>
            {/* //ANCHOR - EDIT - Selezione sede */}
            <div className='uss-user-select-row mt-4'>
                <Form.Label className='no-pm' ><p className='no-pm' >Seleziona Sede:</p></Form.Label>
                <Select
                    id='select-pttp'
                    className='uss-select'
                    components={animatedComponents}
                    options={shopOptions}
                    isSearchable
                    value={userValues.Shop}
                    onChange={(e) => setUserValues(draft => { draft.Shop = e })}
                />
            </div>
            {/* //ANCHOR - EDIT - Selezione gruppo */}
            <div className='uss-user-select-row mt-4'>
                <Form.Label className='no-pm' ><p className='no-pm' >Seleziona gruppo:</p></Form.Label>
                <Select
                    id='select-pttp'
                    className='uss-select'
                    components={animatedComponents}
                    options={groupOptions}
                    isSearchable
                    value={userValues.Group}
                    onChange={(e) => setUserValues(draft => { draft.Group = e })}
                />
            </div>
            {/* //ANCHOR - EDIT - Orari calendario */}
            <p className='uss-form-row mt-4'>{textContext.get(['sidebar', 'settings', 'profile'], ['cal_hours_title'], textContext.value)}</p>
            <div className='uss-form-row'>
                <div className='uss-form-hours-col'>
                    <InputGroup hasValidation>
                        <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'profile'], ['cal_hours_start'], textContext.value)}</InputGroup.Text>
                        <GoodNumber
                            value={userValues.use_calendar_start}
                            min={1}
                            classes='form-control'
                            max={userValues.use_calendar_end}
                            onChange={(e) => setUserValues(draft => { draft.use_calendar_start = e })}
                            onFocus={(e) => setUserCheks(draft => { draft.touched.use_calendar_start = true })}
                            isValid={userCheks.good.use_calendar_start}
                            isInvalid={userCheks.bad.use_calendar_start}

                        />
                    </InputGroup>
                </div>
                <div className='uss-form-hours-col'>
                    <InputGroup hasValidation>
                        <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'profile'], ['cal_hours_end'], textContext.value)}</InputGroup.Text>
                        <GoodNumber
                            value={userValues.use_calendar_end}
                            min={userValues.use_calendar_start}
                            max={24}
                            onChange={(e) => setUserValues(draft => { draft.use_calendar_end = e })}
                            onFocus={(e) => setUserCheks(draft => { draft.touched.use_calendar_end = true })}
                            isValid={userCheks.good.use_calendar_end}
                            isInvalid={userCheks.bad.use_calendar_end}
                            classes='form-control'
                        />
                    </InputGroup>
                </div>
            </div>
            {/* //ANCHOR - EDIT - Colore */}
            <div className='uss-form-row mt-4'>
                <InputGroup>
                    <InputGroup.Text>{textContext.get(['calendar', 'category', 'add_category'], ['color'], textContext.value)}</InputGroup.Text>
                    {!resetColors && (
                        <FormControl
                            type='color'
                            id='colorPicker'
                            defaultValue={userValues.use_color}
                            onChange={(e) => changeColor(e)}
                            onBlur={(e) => { setUserValues(draft => { draft.use_color = colorRef.current }) }}
                        />
                    )}
                </InputGroup>
            </div>
        </div>
    )
}

export default UsersSettings